import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import * as bugCrowdFormStyles from "./bugCrowdForm.module.css";

// cx for CSS Modules
const cx = classnames.bind(bugCrowdFormStyles);

const BugCrowdForm = ({ parentModule, formId }) => {
    const [checked, setChecked] = useState(false);
    const [displayForm, setDisplayForm] = useState(false);

    const Form = ({ displayForm }) => {
        useEffect(() => {
            const formDiv = document.getElementById("bugCrowdForm");
            const script = document.createElement("script");
            script.src = `https://bugcrowd.com/${formId}/external/script`;
            script.async = true;
            script.setAttribute("data-bugcrowd-program", `https://bugcrowd.com/${formId}/external/report`);
            formDiv.appendChild(script);
            return () => {
                formDiv.removeChild(script);
            };
        }, []);

        return <div id="bugCrowdForm" />;
    };

    const handler = (value) => {
        parentModule.current.querySelector(".body").style.display = value ? "none" : "block";
        setDisplayForm(value);
    };

    const Checkbox = () => {
        return (
            <>
                <div className={cx("agreeContainer")}>
                    <input
                        checked={checked}
                        type="checkbox"
                        id="bugcrowd-agreement"
                        name="bugcrowd-agreement"
                        value="bugcrowd-agreement"
                        onChange={(ev) => setChecked(ev.target.checked)}
                    />
                    <label htmlFor="bugcrowd-agreement">I agree to the Legal Terms and Conditions above.</label>
                </div>
                <button
                    disabled={!checked}
                    className={cx("btn", "btnPrimary")}
                    onClick={() => {
                        return handler(checked);
                    }}
                >
                    Continue
                </button>
            </>
        );
    };

    return (
        <>
            {!displayForm && <Checkbox />}
            {displayForm && <Form formId={formId} />}
        </>
    );
};

export default BugCrowdForm;
